// Import model
import { TaxRatesCondition } from '../models/TaxRatesCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { TaxRatesIndexedFields } from '../models/TaxRatesIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { TaxRatesIndexedFieldsSerializer } from './TaxRatesIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for TaxRatesCondition - handles JSON serialization and deserialization with type validation
 */
export class TaxRatesConditionSerializer {
  /**
   * Deserializes a JSON string into a TaxRatesCondition instance
   */
  static deserialize(json: string): TaxRatesCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a TaxRatesCondition instance
   */
  static fromObject(obj: any): TaxRatesCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to TaxRatesCondition');
    }


    const instance: TaxRatesCondition = {
      fieldName: obj['fieldName'] as TaxRatesIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of TaxRatesCondition instances
   */
  static deserializeArray(json: string): TaxRatesCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a TaxRatesCondition instance to a JSON string
   */
  static serialize(instance: TaxRatesCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a TaxRatesCondition instance to a plain object
   */
  static toObject(instance: TaxRatesCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of TaxRatesCondition instances to a JSON string
   */
  static serializeArray(instances: TaxRatesCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
